/* eslint-disable */
export default {
  hide: 'Nascondi',
  end: 'Termina',
  keypad: 'Tastiera',
} as const;

// @key: @#@"hide"@#@ @source: @#@"Hide"@#@
// @key: @#@"end"@#@ @source: @#@"End"@#@
// @key: @#@"keypad"@#@ @source: @#@"Keypad"@#@
